import { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Spinner } from "react-bootstrap";
import API_BASE_URL from "./Config";

export default function VideoUploadForm() {
  const [videoPreview, setVideoPreview] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadedVideos, setUploadedVideos] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [products, setProducts] = useState([]);
  const [modules, setModule] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const token = Cookies.get("token");
  const [showFtpModal, setShowFtpModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      toast.error("You need to log in first.");
      navigate("/");
    }
    fetch(`${API_BASE_URL}products`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.products) {
          setProducts(data.products);
        } else {
          toast.error("Some Error Occured");
        }
      })
      .catch((error) => console.error("Server Error:", error));
  }, []);

  useEffect(() => {
    if (!selectedProduct) return;
    fetch(`${API_BASE_URL}modules/${selectedProduct}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.modules) {
          setModule(data.modules);
        } else {
          toast.error("Some Error Occured");
        }
      })
      .catch((error) => console.error("Server Error:", error));
  }, [selectedProduct]);

  const [formData, setFormData] = useState({
    productId: "",
    fileName: "",
    title: "",
    description: "",
    filename: "",
    keywords: "",
    file: null,
    thumbnail: null,
  });

  const clearFields = () => {
    setFormData({
      productId: "",
      fileName: "",
      title: "",
      description: "",
      filename: "",
      keywords: "",
      file: null,
      thumbnail: null,
    });
    setVideoPreview(null);
    setThumbnailPreview(null);
    setSelectedProduct("");
    setSelectedModule("");
  
    if (fileInputRef.current) fileInputRef.current.value = "";
    if (thumbnailInputRef.current) thumbnailInputRef.current.value = "";

  }

  const fileInputRef = useRef(null);
  const thumbnailInputRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, file: file, fileName: file.name });
      setVideoPreview(URL.createObjectURL(file));
    }
  };

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, thumbnail: file });
      setThumbnailPreview(URL.createObjectURL(file));
    }
  };



  const handleFtpSubmit = async (e) => {
    e.preventDefault();
    const token = Cookies.get("token");
    if (!token) {
      toast.error("You need to log in first.");
      navigate("/");
    }
    if(!selectedProduct || !selectedModule || !formData.fileName || !formData.title || !formData.description || !formData.keywords || !formData.thumbnail ) {
      toast.error("Please fill all the fields before submitting.");
      return;
    }
    const formDataToSend = new FormData();
    const userId = Cookies.get("userId");
    formDataToSend.append("ProductId", selectedProduct);
    formDataToSend.append("FileName", formData.fileName);
    formDataToSend.append("Title", formData.title);
    formDataToSend.append("Description", formData.description);
    formDataToSend.append("Keywords", formData.keywords);
    formDataToSend.append("VideoUrl", "./test");
    formDataToSend.append("ThumbnailUrl", "./test");
    formDataToSend.append("UploadedBy", userId);

    formDataToSend.append("Thumbnail", formData.thumbnail);
    formDataToSend.append("ModuleId", selectedModule);

    formDataToSend.append("Status", "Active");

    setIsUploading(true);
    try {
      const response = await fetch(`${API_BASE_URL}viaFtp`, {
        method: "POST",
        body: formDataToSend,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      let responseData;
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.includes("application/json")) {
        responseData = await response.json(); 
      } else {
        responseData = { message: await response.text() }; 
      }

      if (response.ok) {
        toast.success("Video uploaded successfully");

        setFormData({
          productId: "",
          fileName: "",
          title: "",
          description: "",
          keywords: "",
          file: null,
          thumbnail: null,
        });
        setSelectedProduct("");
        setSelectedModule("");
        setVideoPreview(null);
        setThumbnailPreview(null);

        if (fileInputRef.current) fileInputRef.current.value = "";
        if (thumbnailInputRef.current) thumbnailInputRef.current.value = "";
      } else {
        toast.error(responseData.message || "Video upload failed");
        throw new Error(responseData.message || "Upload failed");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.message || "Video upload failed");
    } finally {
      setIsUploading(false);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = Cookies.get("token");
    if (!token) {
      toast.error("You need to log in first.");
      navigate("/");
    }
    if(!selectedProduct || !selectedModule || !formData.fileName || !formData.title || !formData.description || !formData.keywords || !formData.file || !formData.thumbnail || !formData.fileName) {
      toast.error("Please fill all the fields before submitting.");
      return;
    }

    const formDataToSend = new FormData();
    const userId = Cookies.get("userId");
    formDataToSend.append("ProductId", selectedProduct);
    formDataToSend.append("FileName", formData.fileName);
    formDataToSend.append("Title", formData.title);
    formDataToSend.append("Description", formData.description);
    formDataToSend.append("Keywords", formData.keywords);
    formDataToSend.append("VideoUrl", "./test");
    formDataToSend.append("ThumbnailUrl", "./test");
    formDataToSend.append("UploadedBy", userId);

    formDataToSend.append("Thumbnail", formData.thumbnail);
    formDataToSend.append("ModuleId", selectedModule);

    if (!formData.file) {
      toast.error("Please select a file before uploading.");
      return;
    }
    formDataToSend.append("VideoFile", formData.file);
    formDataToSend.append("Status", "Active");

    setIsUploading(true);
    try {
      const response = await fetch(`${API_BASE_URL}upload`, {
        method: "POST",
        body: formDataToSend,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      let responseData;
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.includes("application/json")) {
        responseData = await response.json(); 
      } else {
        responseData = { message: await response.text() }; 
      }

      if (response.ok) {
        toast.success("Video uploaded successfully");

        setFormData({
          productId: "",
          fileName: "",
          title: "",
          description: "",
          keywords: "",
          file: null,
          thumbnail: null,
        });
        setSelectedProduct("");
        setSelectedModule("");
        setVideoPreview(null);
        setThumbnailPreview(null);

        if (fileInputRef.current) fileInputRef.current.value = "";
        if (thumbnailInputRef.current) thumbnailInputRef.current.value = "";
      } else {
        toast.error(responseData.message || "Video upload failed");
        throw new Error(responseData.message || "Upload failed");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.message || "Video upload failed");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="container-fluid p-0">
      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-8">
                    <div
                      className="card-header bg-white py-3 mb-3"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "start",
                      }}
                    >
                      <div className="col-6">
                        <h4 className="card-title mb-0">Upload New Video</h4>
                      </div>
                      <div className="col-6">
                        <button
                          type="button"
                          className="btn btn-primary btn-md float-end"
                          onClick={() => setShowFtpModal(true)}
                        >
                          <i className="bi bi-file-earmark-arrow-up-fill"></i> Register Uploaded Video
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6 mb-3">
                        <div className="mb-3">
                          <label
                            htmlFor="productSelect"
                            className="form-label fw-semibold"
                          >
                            Select a Product
                          </label>
                          <select
                            id="productSelect"
                            className="form-select"
                            value={selectedProduct}
                            onChange={(e) => setSelectedProduct(e.target.value)}
                            required
                          >
                            <option value="">-- Select Product --</option>
                            {products.map((product) => (
                              <option
                                key={product.productId}
                                value={product.productId}
                              >
                                {product.productName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6 mb-3">
                        <div className="mb-3">
                          <label
                            htmlFor="productSelect"
                            className="form-label fw-semibold"
                          >
                            Select a Module
                          </label>
                          <select
                            id="productSelect"
                            className="form-select"
                            value={selectedModule}
                            onChange={(e) => setSelectedModule(e.target.value)}
                            required
                          >
                            <option value="">-- Select Module --</option>
                            {modules.map((module) => (
                              <option
                                key={module.moduleId}
                                value={module.moduleId}
                              >
                                {module.moduleName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label
                        className="form-label fw-semibold"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                        }}
                      >
                        Video Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={formData.title}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter video title"
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        className="form-label fw-semibold"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                        }}
                      >
                        Description
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter video Description"
                      />
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label fw-semibold"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                        }}
                      >
                        Keywords
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="keywords"
                        value={formData.keywords}
                        onChange={handleInputChange}
                        placeholder="Enter keywords separated by commas"
                      />
                    </div>
                    <div className="row">
                      <div className="col-lg-6 mb-3">
                        <div className="mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            Video File
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            accept="video/*"
                            onChange={handleFileChange}
                            ref={fileInputRef}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 mb-3">
                        <div className="mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            Thumbnail Image
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={handleThumbnailChange}
                            ref={thumbnailInputRef}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label
                        className="form-label fw-semibold"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                        }}
                      >
                        File Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="fileName"
                        value={formData.fileName}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter File Name"
                      />
                    </div>
                  </div>

                  <div className="col-lg-4 bg-light p-4 rounded border">
                    <div
                      className="card-header bg-light mb-4"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "start",
                      }}
                    >
                      <h5 className="mb-0">
                        <i className="bi bi-eye"></i> &nbsp;Preview
                      </h5>
                    </div>

                    {videoPreview ? (
                      <div className="mb-3">
                        <div className="ratio ratio-16x9 mb-3 bg-dark rounded">
                          <video
                            src={videoPreview}
                            controls
                            className="rounded"
                          ></video>
                        </div>
                      </div>
                    ) : (
                      <div className="mb-3 text-center py-4 bg-dark bg-opacity-10 rounded">
                        <div className="py-4">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="48"
                            height="48"
                            fill="currentColor"
                            className="bi bi-file-earmark-play text-muted mb-2"
                            viewBox="0 0 16 16"
                          >
                            <path d="M6 6.883v4.234a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858L6.757 6.454a.5.5 0 0 0-.757.43z" />
                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                          </svg>
                          <p className="text-muted">
                            Video preview will appear here
                          </p>
                        </div>
                      </div>
                    )}

                    {thumbnailPreview ? (
                      <div>
                        <div className="mb-3 bg-dark rounded">
                          <img
                            src={thumbnailPreview || "/placeholder.svg"}
                            alt="Thumbnail preview"
                            className="img-fluid rounded w-100"
                            style={{ maxHeight: "150px", objectFit: "cover" }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="text-center py-3 bg-dark bg-opacity-10 rounded">
                        <div className="py-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="48"
                            height="48"
                            fill="currentColor"
                            className="bi bi-image text-muted mb-2"
                            viewBox="0 0 16 16"
                          >
                            <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                            <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z" />
                          </svg>
                          <p className="text-muted small">
                            Thumbnail preview will appear here
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className="alert alert-info d-flex align-items-center mt-3"
                  role="alert"
                >
                  <i className="bi bi-info-circle me-2"></i>
                  <div>
                    <strong>Note:</strong> Supported formats are MP4, WebM, and
                    MOV.
                  </div>
                </div>

                <div className="d-flex justify-content-end gap-2 mt-4">
                  <button
                    type="button"
                    className="btn btn-danger btn px-4"
                    onClick={clearFields}
                  >
                    Clear
                  </button>
                  <button type="submit" className="btn btn-primary btn px-4">
                    {isUploading ? (
                      <>
                        <Spinner animation="border" size="sm" /> Uploading...
                      </>
                    ) : (
                      "Upload Video"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {showFtpModal && (
        <div
          className="modal modal-lg fade show d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
              <h3>Upload Details</h3>
                <button
                  className="btn-close"
                  onClick={() => setShowFtpModal(false)}
                ></button>
              </div>
              <div className="modal-body">
              <div
                  className="alert alert-info d-flex align-items-center  mt-1"
                  role="alert"
                >            
                  <div>
                    <strong>Important:</strong>   Make sure the video file is already uploaded to cPanel using FTP. Please give the same name to the file you are uploading as the one you have already uploaded to cPanel.
                  </div>
                </div>

                <div className="col-lg-12 p-5 pt-3 bg-light rounded border">
                    <div className="row">
                      <div className="col-lg-6 mb-3">
                      
                          <label
                            htmlFor="productSelect"
                            className="form-label fw-semibold"
                          >
                            Select a Product
                          </label>
                          <select
                            id="productSelect"
                            className="form-select"
                            value={selectedProduct}
                            onChange={(e) => setSelectedProduct(e.target.value)}
                            required
                          >
                            <option value="">-- Select Product --</option>
                            {products.map((product) => (
                              <option
                                key={product.productId}
                                value={product.productId}
                              >
                                {product.productName}
                              </option>
                            ))}
                          </select>
                       
                      </div>
                      <div className="col-lg-6 mb-3">
                        
                          <label
                            htmlFor="productSelect"
                            className="form-label fw-semibold"
                          >
                            Select a Module
                          </label>
                          <select
                            id="productSelect"
                            className="form-select"
                            value={selectedModule}
                            onChange={(e) => setSelectedModule(e.target.value)}
                            required
                          >
                            <option value="">-- Select Module --</option>
                            {modules.map((module) => (
                              <option
                                key={module.moduleId}
                                value={module.moduleId}
                              >
                                {module.moduleName}
                              </option>
                            ))}
                          </select>
                        
                      </div>
                    </div>
                    <div className="mb-3">
                      <label
                        className="form-label fw-semibold"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                        }}
                      >
                        Video Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={formData.title}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter video title"
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        className="form-label fw-semibold"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                        }}
                      >
                        Description
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter video Description"
                      />
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label fw-semibold"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                        }}
                      >
                        Keywords
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="keywords"
                        value={formData.keywords}
                        onChange={handleInputChange}
                        placeholder="Enter keywords separated by commas"
                      />
                    </div>
                    <div className="row">
                      <div className="col-lg-6 mb-3">
                      <div className="mb-3">
                      <label
                        className="form-label fw-semibold"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                        }}
                      >
                        File Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="fileName"
                        value={formData.fileName}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter File Name"
                      />
                    </div>
                      </div>
                      <div className="col-lg-6 mb-3">
                        <div className="mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            Thumbnail Image
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={handleThumbnailChange}
                            ref={thumbnailInputRef}
                          />
                        </div>
                      </div>
                    </div>
                    
                  </div>
              </div>
              <div className="d-flex justify-content-end gap-2 mt-4 modal-footer">
                <button
                  type="button"
                  className="btn btn-danger btn px-4"
                  onClick={() => setShowFtpModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary btn px-4" onClick={handleFtpSubmit}>
                {isUploading ? (
                      <>
                        <Spinner animation="border" size="sm" /> Uploading...
                      </>
                    ) : (
                      "Upload"
                    )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
